// src/services/adminApi.js
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const getOrders = () => {
  try {
    return axios.get(`${API_BASE_URL}/orders`);
  } catch (error) {
    console.error("Erreur lors de la recupération des commandes :", error);
    throw error;
  }
};

export const getProducts = () => {
  try {
    return axios.get(`${API_BASE_URL}/products`);
  } catch (error) {
    console.error("Erreur lors de la recupération des produits :", error);
    throw error;
  }
};

export const updateOrderStatus = (orderId, status) => {
  try {
    return axios.put(
      `${API_BASE_URL}/orders/${orderId}/status`,
      { status }
    );
  } catch (error) {
    console.error(
      "Erreur lors de la mise à jour du statut de la commande :",
      error
    );
    throw error;
  }
};

export const validateOrder = (orderId) => {
  try {
    return axios.put(
      `${API_BASE_URL}/orders/${orderId}/validate`,
      {}
    );
  } catch (error) {
    console.error("Erreur lors de la validation de la commande :", error);
    throw error;
  }
};

export const updateProductStock = (productId, stock) => {
  try {
    return axios.put(
      `${API_BASE_URL}/products/${productId}/stock`,
      { stock }
    );
  } catch (error) {
    console.error("Erreur lors de la mise à jour du stock :", error);
    throw error;
  }
};

export const deleteOrder = (orderId) => {
  try {
    return axios.delete(`${API_BASE_URL}/orders/${orderId}`);
  } catch (error) {
    console.error("Erreur lors de la suppression de la commande :", error);
    throw error;
  }
};

